import { NotificationCountBadge } from "@dash/nav";

import { SignalDoc, SignalType } from "@megaron/docs-contracts";

import { navBadgeGroupCount } from "./persistentSignals";

type Props = {
  signals: SignalDoc[];
  badgeSignalTypes: readonly SignalType[];
  color: string;
};

export const SignalsBadge: React.FC<Props> = ({ signals, badgeSignalTypes, color }) => {
  const groupCount = navBadgeGroupCount(signals, badgeSignalTypes);

  if (groupCount === 0) return null;

  return (
    <span
      css={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        lineHeight: 0,
        pointerEvents: "none",
      }}
    >
      <NotificationCountBadge count={groupCount} backgroundColor={color} color="white" withShadow={false} />
    </span>
  );
};
